
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.11.53l-1.12 1.12 3.36 3.36 1.12-1.12L14.11.53zM1.09 13.55l-.56 3.92 3.92-.56L15.3 6.06 11.94 2.7 1.09 13.55z","fill":"#000"}})])
          )
        }
      }
    